<template>
    <el-col :span="+col" class="s">
      <div class="term">{{dataSource.label}}</div>
      <div class="detail"><span v-if="dataSource.text">{{dataSource.text}}</span><slot></slot></div>
    </el-col>
</template>

<script>
const handleData = d => {
  let text = d.text
  if (d.formatter) {
    text = d.formatter.call(this, text)
  }
  return {
    label: d.label,
    text: text
  }
}
export default {
  name: 'ZDisplay',
  props: {
    label: [String, Number],
    text: [String, Number, Object],
    title: String,
    content: [Object, Array],
    col: {
      type: [Number, String],
      default: 6
    },
    formatter: {
      type: Function
    }
  },
  created () {
    // this.formatters(this.text)
  },
  methods: {
  },
  data () {
    return {
     dataSource: handleData(this)
    }
  },
  watch: {
    text (oldVal, newVal) {
      this.dataSource = handleData(this)
    } // 监听重渲染
  }
}
</script>

<style lang="less" scoped>
.term {
    color: rgba(0,0,0,.85);
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    // padding-bottom: 16px;
    margin-right: 8px;
    white-space: nowrap;
    display: table-cell;
    min-width: 70px;
    text-align: right;
    &:after {
      content: ":";
      margin: 0 8px 0 2px;
      position: relative;
      top: -0.5px;
    }
  }
  .detail {
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    // padding-bottom: 16px;
    color: rgba(0, 0, 0, 0.65);
    display: table-cell;
    text-align: left;
  }
  .s {
    display: inline;
    padding: 5px 30px;
    float: left;
  }
.description_text {
  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 20px;
    color: rgba(0, 0, 0, 0.85);
  }
  .term {
    color: rgba(0,0,0,.85);
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 16px;
    margin-right: 8px;
    white-space: nowrap;
    display: table-cell;
    min-width: 70px;
    text-align: right;
    &:after {
      content: ":";
      margin: 0 8px 0 2px;
      position: relative;
      top: -0.5px;
    }
  }
  .detail {
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    padding-bottom: 16px;
    color: rgba(0, 0, 0, 0.65);
    display: table-cell;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/description/ZDisplay.vue